export default __webpack_public_path__ + "static/media/art_ambassadors.a9215771.png";